import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

export const Button = styled(CommonButton)`
  display: inline-block;
  background: white;
  border-color: #747775;
  box-shadow:
    0px 2px 2px rgba(0, 0, 0, 0.05),
    0px 5px 10px rgba(0, 0, 0, 0.1);
  color: black;

  &:hover, &:focus {
    background: #eee;
    color: black;
  }

  &:focus-visible {
    background: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);
    color: black;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin-right: 12px;
  vertical-align: -26%;
`;
